module.exports = __webpack_public_path__ + "static/media/Icon - X - Black.c3efdf62.svg";